import { giphyLightGrey } from '@giphy/colors'
import styled from 'styled-components'

const Copy = styled.div`
    color: ${giphyLightGrey};
    font-size: 16px;
    margin-right: 40px;
    text-align: center;
    width: 100%;

    a {
        color: inherit;
        font-weight: bold;
        text-decoration: none;
    }

    strong {
        color: #fff;
        font-size: 20px;
        line-height: 24px;
    }
`

const PlayIcon = styled.svg`
    flex-shrink: 0;
    opacity: 0.5;
`

const Container = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    font-family: 'interface', 'Helvetica Neue', helvetica, sans-serif;
    height: 80px;
    justify-content: center;
    padding: 15px;
    position: relative;
    width: 100%;

    @media (max-width: 480px) {
        ${Copy} {
            margin-right: 0;
        }
        ${PlayIcon} {
            display: none;
        }
    }
`

const Video404Footer = () => (
    <Container>
        <PlayIcon width="40" height="40" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M40 0v40H0V0h40zM14.077 9.637a.714.714 0 00-.371.107l-.022 21.11a.562.562 0 00.365.117c.098 0 5.324-3.367 15.679-10.1a.345.345 0 00.143-.275.345.345 0 00-.143-.277L14.435 9.744a.695.695 0 00-.358-.107z"
                    fill="#FFF"
                    fillRule="nonzero"
                />
                <path
                    d="M14.077 9.637c.12 0 .239.036.358.107L29.728 20.32c.096.078.143.17.143.277a.345.345 0 01-.143.276c-10.355 6.732-15.58 10.099-15.68 10.099a.562.562 0 01-.364-.116l.022-21.11a.714.714 0 01.37-.108z"
                    opacity=".5"
                />
            </g>
        </PlayIcon>
        <Copy>
            <strong>This video doesn&apos;t exist!</strong>
            <br />
            Visit{' '}
            <a href="https://giphy.com" target="_parent">
                GIPHY.com
            </a>{' '}
            for the best content on the internet
        </Copy>
    </Container>
)

export default Video404Footer
